export { default } from '@rockalingua/ui/hooks/useMediaQuery.hook';
